import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { Text } from "../Text";
import "./NumberField.scss";

export class NumberField extends React.Component {
  static defaultProps = {
    disabled: false,
    defaultValue: "",
    placeholder: "",
    integer: false,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Callback function for when number field's input is changed */
    onChange: PropTypes.func,
    /** Whether the number field's input can be changed */
    disabled: PropTypes.bool,
    /** Id associated with component */
    id: PropTypes.any,
    /** Label associated with component */
    label: PropTypes.string,
    /** Message to be displayed */
    message: PropTypes.string,
    /** Message type */
    messageType: PropTypes.string,
    /** Placeholder associated with component */
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** The default value of the NumberField */
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** If input should autofocus */
    autoFocus: PropTypes.bool,
    /** If imput should be return as an integer in the system (truncates the decimal) */
    integer: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue,
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultValue } = this.props;

    this.updateDefaultValueStateIfPropChanged(
      defaultValue,
      prevProps.defaultValue
    );
  }

  updateDefaultValueStateIfPropChanged = (
    newDefaultValue,
    previousDefaultValue
  ) => {
    if (newDefaultValue !== previousDefaultValue) {
      this.setState({ value: newDefaultValue });
    }
  };

  onChange = (event) => {
    const { disabled, id, onChange } = this.props;
    const { value } = event.target;

    const valueAsNumber = this.convertTextValueToNumber(value);

    this.setState({ value });

    if (!disabled) {
      if (onChange) {
        if (id) {
          onChange({
            id,
            value: valueAsNumber,
          });
        } else {
          onChange(valueAsNumber);
        }
      }
    }
  };

  convertTextValueToNumber = (textValue) => {
    const { integer } = this.props;

    if (textValue === "" || textValue === undefined || textValue === null) {
      return undefined;
    }

    if (integer) {
      return parseInt(textValue, 10);
    }

    return parseFloat(textValue);
  };

  disableNumberFieldsScroll = (event) => {
    return event.target.blur();
  };

  render() {
    const {
      autoFocus,
      className,
      disabled,
      id,
      integer,
      label,
      message,
      messageType,
      placeholder,
    } = this.props;

    const { value } = this.state;

    const numberFieldClass = classNames(
      className,
      "numberField",
      { "numberField--disabled": disabled },
      { "numberField--error": messageType === "error" },
      { "numberField--warning": messageType === "warning" }
    );

    const integerProps = {};

    if (integer) {
      integerProps.step = "1";
    }

    return (
      <div className={numberFieldClass}>
        {label && <label htmlFor={id}>{label}</label>}
        <input
          id={id}
          className="numberField__input"
          type="number"
          tabIndex={0}
          onChange={this.onChange}
          placeholder={placeholder}
          value={value}
          autoFocus={autoFocus}
          onWheelCapture={this.disableNumberFieldsScroll}
          {...integerProps}
        />
        {message && (
          <Text className="numberField__message" type="S">
            {message}
          </Text>
        )}
      </div>
    );
  }
}

export default NumberField;
